// ABOUTME: Root app layout that owns the environment chrome and the routed content slot.
// ABOUTME: Routes with full-bleed overlays (e.g. Login) are scoped to the content area only.
import { PropsWithChildren } from 'react';
import { EnvironmentIndicator, EnvironmentBanner } from './EnvironmentIndicator';
import './AppShell.css';

function EnvironmentChrome() {
  return (
    <header className="environment-chrome" data-testid="environment-chrome">
      <div className="environment-bar">
        <EnvironmentIndicator />
      </div>
      <EnvironmentBanner />
    </header>
  );
}

export function AppShell({ children }: PropsWithChildren) {
  return (
    <div className="app-shell">
      <EnvironmentChrome />
      <main className="app-shell__content">{children}</main>
    </div>
  );
}
